import { render, staticRenderFns } from "./LicenseEditDialog.vue?vue&type=template&id=0533b210&scoped=true"
import script from "./LicenseEditDialog.vue?vue&type=script&lang=js"
export * from "./LicenseEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0533b210",
  null
  
)

export default component.exports